import {FC} from 'react'
import {Navigate, Route, Routes as RouterRoutes} from 'react-router-dom'
import {shallowEqual, useSelector} from 'react-redux'
import {MasterLayout} from '../../_metronic/layout/MasterLayout'
import {PrivateRoutes} from './PrivateRoutes'
import {Logout, AuthPage} from '../modules/auth'
import {ErrorsPage} from '../modules/errors/ErrorsPage'
import {RootState} from '../../setup'

const Routes: FC = () => {
    const isAuthorized = useSelector<RootState>(({auth}) => auth.user, shallowEqual)

    return (
        <RouterRoutes>
            {!isAuthorized ? (
                <Route path='/*' element={<AuthPage />} />
            ) : (
                <>
                    <Route path='/autenticacao/*' element={<Navigate to='/' replace />} />
                    <Route path='/error/*' element={<ErrorsPage />} />
                    <Route path='/logout/*' element={<Logout />} />
                    <Route
                        path='/*'
                        element={
                            <MasterLayout>
                                <PrivateRoutes />
                            </MasterLayout>
                        }
                    />
                </>
            )}
        </RouterRoutes>
    )
}

export {Routes}
